// extracted by mini-css-extract-plugin
export default {"container":"ImageLoader_container__3F7bn","flare":"ImageLoader_flare__wPvVF","animation-image-loader":"ImageLoader_animation-image-loader__2LlO5"};